import {CSSProperties, FC} from 'react';


export interface IIconTradeInProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconTradeIn: FC<IIconTradeInProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M5.448 7.408 8 12H5.6a6.4 6.4 0 0 0 10.832 4.618l.798 1.436A8 8 0 0 1 5.448 7.408ZM12 4a8 8 0 0 1 6.552 12.592L16 12h2.4A6.4 6.4 0 0 0 7.568 7.382L6.77 5.946A7.969 7.969 0 0 1 12 4Zm1.684 5.5a.6.6 0 0 1 .562.36L15 11.723v2.5c0 .154-.134.278-.3.278h-.3c-.166 0-.3-.124-.3-.278v-.278H9.9v.278c0 .154-.134.278-.3.278h-.3c-.166 0-.3-.124-.3-.278v-2.5l.754-1.861a.6.6 0 0 1 .562-.361h3.368Zm-3.334 2.778c-.248 0-.45.186-.45.416 0 .23.201.417.45.417.248 0 .45-.186.45-.417 0-.23-.202-.416-.45-.416Zm3.3 0c-.248 0-.45.186-.45.416 0 .23.202.417.45.417s.45-.186.45-.417c0-.23-.201-.416-.45-.416Zm.034-2.222h-3.368l-.675 1.666h4.718l-.675-1.666Z" clipRule="evenodd" />
        </svg>
    );
};
